<template lang="pug">
  .advantage
    h1(:class="titleAnimation") 解决方案优势
    .cards
      .card(v-for="(card, index) in advatages" :class="[contentAnimation, `animateDelay-${index}`]")
        .background
        .img(:class="icon(card.title)")
        h3 {{ card.title }}
        p.text {{ card.text }}
</template>

<script>
  import Mixin from '../../index.js'
  export default {
    name: "advantage",
    mixins: [Mixin],
    props: {
      advatages: Array,
    },
    methods: {
      icon(title) {
        const classList = {
          专业的AI教育教学体系: 'img1',
          教学实践助力产教融合: 'img2',
          '安全稳定，隐私保护': 'img3',
          企业运营降本增效: 'img4',
          低成本: 'img5',
        };
        return classList[title];
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .advantage {
    VStack(center)
    padding 100px 0
    background-color: #f8f8f8;
    border-top 1px solid #e4e4e4
    border-bottom 1px solid #e4e4e4
    .cards {
      HStack(center, center)
      flex-wrap wrap
      margin -20px 0
      max-width 1200px
      .card {
        margin 20px
        padding 10px
        width 360px
        height 225px
        border 1px solid #e4e4e4
        background white
        border-radius 16px
        box-sizing border-box
        position relative
        VStack()
        > * {
          z-index 1
        }
        .img {
          width 80px
          height 80px
          background-repeat no-repeat
          background-position center
          background-size 80px
        }
        h3 {
          FontSetting("思源黑体")
          font-weight 400
          color #202020
          font-size 20px
          padding 0 20px
          margin 0
        }
        .text {
          font-size 16px
          line-height 24px
          FontSetting("思源黑体")
          font-weight 300
          color #202020
          padding 0 20px
          margin 0
          margin-top 10px
        }
        &::before, &::after {
          content ""
          position absolute
          top 0
          left 0
          width 100%
          height 100%
          transition all .3s
          z-index -1
          border-radius 16px
          background linear-gradient(30deg, #1f83ff, #39e1ff)
        }
        &::before {
          opacity .3
        }
        &::after {
          opacity .1
        }
        .background {
          border-radius 16px
          background linear-gradient(white, white)
          position absolute
          top 0
          left 0
          width 100%
          height 100%
          box-sizing border-box
          transition all .3s
          z-index 0
        }
        &:hover {
          .background {
            background linear-gradient(30deg, #1f83ff, #39e1ff)
          }
          .text, h3 {
            color white
          }
          &::before {
            transform translateY(16px) scale(.944444)
            border-radius 8px
          }
          &::after {
            transform translateY(32px) scale(.888889)
            border-radius 8px
          }
        }
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0 20px
      .cards {
        .card {
          position relative
          padding-top 50px
          .img {
            position absolute
            top 10px
            right 10px
          }
        }
      }
    }
  }
  .img1 {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%B8%93%E4%B8%9A%E7%9A%84AI%E6%95%99%E8%82%B2%E6%95%99%E5%AD%A6%E4%BD%93%E7%B3%BB.png");
  }
  .img2 {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E6%95%99%E5%AD%A6%E5%AE%9E%E8%B7%B5%E5%8A%A9%E5%8A%9B%E4%BA%A7%E6%95%99%E8%9E%8D%E5%90%88.png");
  }
  .img3 {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E5%AE%89%E5%85%A8%E7%A8%B3%E5%AE%9A.png");
  }
  .img4 {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%BC%81%E4%B8%9A%E8%BF%90%E8%90%A5%E9%99%8D%E6%9C%AC%E5%A2%9E%E6%95%88.png");
  }
  .img5 {
    background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%BD%8E%E6%88%90%E6%9C%AC.png");
  }
  .card {
    &:hover {
      .img1 {
        background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%B8%93%E4%B8%9A%E7%9A%84AI%E6%95%99%E8%82%B2%E6%95%99%E5%AD%A6%E4%BD%93%E7%B3%BB2.png");
      }
      .img2 {
        background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E6%95%99%E5%AD%A6%E5%AE%9E%E8%B7%B5%E5%8A%A9%E5%8A%9B%E4%BA%A7%E6%95%99%E8%9E%8D%E5%90%882.png");
      }
      .img3 {
        background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E5%AE%89%E5%85%A8%E7%A8%B3%E5%AE%9A2.png");
      }
      .img4 {
        background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%BC%81%E4%B8%9A%E8%BF%90%E8%90%A5%E9%99%8D%E6%9C%AC%E5%A2%9E%E6%95%882.png");
      }
      .img5 {
        background-image url("https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E5%B0%8F%E5%9B%BE/%E4%BD%8E%E6%88%90%E6%9C%AC2.png");
      }
    }
  }
</style>
